import * as React from 'react';
import { useTranslation } from 'react-i18next';
import s from './ErrorBoundaries.scss';
import { Heading, Text, TextButton } from '@wix/design-system';

export const DesktopErrorBoundary: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Heading>{t('app.global_error.title')}</Heading>
      <div className={s.content}>
        <Text weight='normal'>{t('app.global_error.content')}</Text>&nbsp;
        <TextButton
          as='a'
          onClick={() => {
            window.open(t('app.global_error.cta_link'));
          }}
          weight='normal'
          underline='always'
        >
          {t('app.global_error.cta')}
        </TextButton>
      </div>
    </>
  );
};
